module.exports = __webpack_public_path__ + "img/1027.b0cce339.png";